// linted 2020-08-17

import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import IntegerAnswer from './IntegerAnswer';
import PhoneNumberAnswer from './PhoneNumberAnswer';
import TextEntryAnswer from './TextEntryAnswer';
import YesNoAnswer from './YesNoAnswer';
import CheckboxAnswer from './CheckboxAnswer';
import ChoiceAnswer from './ChoiceAnswer';
import TextOnlyAnswer from './TextOnlyAnswer';
import PicklistAnswer from './PicklistAnswer';

// All styling that must be in a javascript file is here
// This allows us to override higher-priority MUI CSS

const theme = createMuiTheme({
    palette: {
        error: {
            main: '#c00'
        },
    },
    overrides: {
        MuiFormLabel: {
            root: {
                'font-size': '16px',
                color: 'black',
                '&$focused': {
                    color: 'black'
                }
            }
        },
        MuiFormHelperText: {
            root: {
                'font-size': '12px'
            },
            '&$error': {
                'font-size': '16px'
            }
        },
        Mui: {
            '&$error': {
                'font-size': '16px'
            }
        },
        MuiInputBase: {
            root: {
                'font-size': '12px'
            }
        },
        MuiInput: {
            input: {
                'font-size': '16px'
            }
        },
        MuiTypography: {
            body1: { 'font-size': '16px' }
        },
        PrivateSwitchBase: {
            // Name of the component / style sheet
            input: {
                // Name of the rule
                color: 'black',
                '&$focused': {
                    // increase the specificity for the pseudo class
                    color: 'black'
                }
            }
        }
    }
});

export default class Question extends React.Component {
    constructor(props) {
        super(props);
        this.components = {
            Integer: IntegerAnswer,
            Number: IntegerAnswer,
            PhoneNumber: PhoneNumberAnswer,
            TextEntry: TextEntryAnswer,
            YesNo: YesNoAnswer,
            Checkbox: CheckboxAnswer,
            Choice: ChoiceAnswer,
            TextOnly: TextOnlyAnswer,
            Picklist: PicklistAnswer
        };
    }

    render() {
        const AnswerTagName = this.components[this.props.question.answerType.answerTypeAlias];
        if (!AnswerTagName) return '';

        return (
            <ThemeProvider theme={theme}>
                <div style={{ paddingBottom: '1em' }} key={`a${this.props.question.questionID}`}>
                    <AnswerTagName
                        question={this.props.question}
                        responseHandler={this.props.responseHandler}
                        invalid={this.props.invalid}
                        validateField={this.props.validateFunction}
                        error={!!this.props.errorText}
                        disabled={this.props.disabled}
                        helperText={this.props.errorText}
                        questionnaire={this.props.questionnaire}
                    />
                </div>
            </ThemeProvider>
        );
    }
}
